// Include the different bits needed in this page
// @codekit-prepend "./util/util"
// @codekit-prepend "./lib/swiper.min.js"

let Realizzazione = {

    // Grab the items
    counter : document.querySelector('.finitura-info-current'),
    section : document.querySelector('.realizzazione-details'),
    btn     : document.querySelector('.realizzazione-info-button'),

    // Liftoff function
    liftoff : function () {

        this.sliderInit();
        this.toggleInfo();

    },


    // Init slider
    sliderInit : function() {

    // Grab the items
    

        var flkty = new Flickity( '.finitura-slides', {
            pageDots : false,
            arrowShape: { 
              x0: 20,
              x1: 60, y1: 50,
              x2: 65, y2: 50,
              x3: 25
            }
        });

        flkty.on( 'change', function( index ) {
            Realizzazione.counter.innerHTML = index + 1
        });

    },

    // Info Toggle Function
    toggleInfo : function() {

        // Check if we have both items on the page
        if (this.btn && this.section) {
            this.btn.addEventListener('click' , (event) => {
                this.section.classList.toggle('is-active');
                this.btn.classList.toggle('is-active');
            });
        }
    }
}

Realizzazione.liftoff();